export const orgHasSetting = (orgData, setting) => {
  return orgData?.settings?.indexOf(setting) > -1 || false;
};

export const orgHasLicense = (orgData, licenseName) => {
  return orgData?.licenses?.[0]?.skus?.[0]?.name === licenseName;
};
